<div class="row client-todos" *ngIf="currentTodo">
  <div class="medium-4 single-todo" *ngIf="isCustomer">
    <div class="row todo-header">
      <div class="small-12 medium-9 columns client-name">
        {{currentTodo.clientName}}
      </div>
      <div class="small-12 medium-3 columns client-name" style="color: #4554A4" *ngIf="isCustomer">
        {{currentTodo.priority}}
      </div>
    </div>
    <div class="row todo-body">
      <div class="small-12 medium-12 columns title">
        {{currentTodo.title}}
      </div>
      <div class="small-12 medium-12 columns desc" style="height: 175px !important;">
        <div [froalaView]="currentTodo.description | linky:{stripPrefix: false, newWindow: true}"></div>
      </div>
      <div class="small-12 medium-12 columns" style="margin-bottom: 1rem" *ngFor="let attachment of attachments">
        <div class="row todo-attach">
          <div class="medium-8 commonColor2  pointer">
            <div class="attachment_name" style="overflow: hidden;text-overflow: ellipsis;display: inherit;white-space: nowrap;" (click)="downloadDocument(attachment.id, 'preview')">{{attachment.name}}</div>
          </div>
          <div class="column medium-4">
            <i class="icon ion-ios-cloud-download-outline commonColor2 float-right" (click)="downloadDocument(attachment.id)"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="row todo-footer">
      <div class="small-12 medium-4 columns" style="color: #5376E3">
        {{currentTodo.type}}
      </div>
      <div class="small-12 medium-4 columns" style="color: #F06459" *ngIf="isCustomer">
        {{currentTodo.dueDate}}
      </div>
      <div class="small-12 medium-4 columns text-right">
        <span class="stat-done" *ngIf="currentTodo.status == 'Done'">{{currentTodo.status}}</span>
        <span class="stat-assign" *ngIf="currentTodo.status == 'Assigned'">{{currentTodo.status}}</span>
      </div>
    </div>
    <div class="medium-9 columns todo-button float-left " *ngIf="!isStatusDone">
      <div class="todo-btn">
        <button class="button small btn-bg float-right stat-done" (click)="moveNextStatus('status')">MARK AS DONE</button>
      </div>
    </div>
    <div class="medium-9 columns todo-button float-left" *ngIf="isStatusDone">
      <div class="todo-btn">
        <button class="button small btn-bg float-right stat-assign" (click)="moveNextStatus('status')">MARK AS ASSIGNED</button>
      </div>
    </div>
  </div>
  <div class="medium-4 single-todo" *ngIf="!isCustomer">
    <div class="row todo-header">
      <div class="small-12 medium-9 columns client-name">
        {{currentTodo.clientName}}
      </div>
      <div class="small-12 medium-3 columns client-name" *ngIf="!isCustomer" style="font-size: 14px;padding: 0px;margin-top: -4px;">
        <app-tpiq-select-dropdown [setData]="priorities" [setPlaceHolder]="'Priority'" [setSearchKey]="'value'" [setValueKey]="'key'" (onValueSelect)="setPriority($event)" [setDefaultValue]="currentTodo.priority"></app-tpiq-select-dropdown>
      </div>
    </div>
    <div class="row todo-body">
      <div class="small-12 medium-12 columns title">
        <input type="text" style="color: #110646 !important;" class="todo-title-input" placeholder="Todo Title" [(ngModel)]="currentTodo.title">
      </div>
      <div class="small-12 medium-11 columns">
        <!--<textarea rows="5" class="todo-title-desc" placeholder="Description..." [(ngModel)]="currentTodo.description"></textarea>-->
        <div style="border: 1px solid  #cacaca !important;padding: 10px;color: #0a0a0a !important;" [froalaEditor]="todoDescriptionEditorOptions"  [(froalaModel)]="currentTodo.description"></div>
      </div>
      <div class="row" style="margin-left: 12px">
        <div class="small-12 medium-12">
          <div class="small-6 medium-12" style="margin-top: 5px">
            <label for="globalNativeFileUpload">
              <span style="cursor: pointer"><i class="material-icons" style="font-size: 18px;color: #878787;vertical-align: middle">attach_file</i>Attach File</span>
            </label>
          </div>
          <input type="file" id="globalNativeFileUpload" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
        </div>
        <div class="small-12 medium-12">
          <div class="file-upload-modal">
            <section>
              <div class="row files-to-upload-section">
                <div class="small-12 medium-12 columns" style="padding-left: 0px;margin-left: -10px">
                  <ul *ngIf="uploader.queue.length>0" style="list-style-type: none;">
                    <li *ngFor="let item of uploader.queue">
                      <div class="row">
                        <div class="column small-10 medium-10" [ngClass]="{'item-uploaded':item.isSuccess}">
                                                    <span *ngIf="!(item.isReady || item.isUploading || item.isSuccess)">
                                                        <i class="ion-ios-cloud-upload-outline" (click)="item.upload()"></i>
                                                    </span>{{ item?.file?.name }} &nbsp;({{ item?.file?.size/1024/1024 | number:'.2' }} MB)
                        </div>
                        <div class="column small-2 text-right">
                          <i *ngIf="(item.isUploading)" class="ion-ios-close-outline" (click)="item.cancel()"></i>
                          <i class="ion-ios-minus-outline" (click)="removeUploadItem(item)"></i>
                        </div>
                      </div>
                      <div *ngIf="item.isUploading">
                        <div class="progress">
                          <div class="progress-meter" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="small-12 medium-12 attachment" *ngFor="let attachment of attachments">
          <div class="row todo-attach">
            <div class="medium-8 commonColor2  pointer">
              <div class="attachment_name" style="overflow: hidden;text-overflow: ellipsis;display: inherit;white-space: nowrap;" (click)="downloadDocument(attachment.id, 'preview')">{{attachment.name}}</div>
            </div>
            <div class="column medium-4">
              <i class="icon ion-ios-cloud-download-outline commonColor2 float-right" (click)="downloadDocument(attachment.id)"></i>
              <i class="icon ion-ios-trash commonColor2 float-right" style="padding-right: 10px" (click)="removeAttachment(attachment)"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="small-12 medium-12 columns" style="text-align: right;margin-top: 10px">
        <button class="button small" style="font-size: 13px;" (click)="moveNextStatus('save')">{{"SAVE"}}</button>
      </div>
    </div>

    <div class="row todo-footer">
      <div class="small-12 medium-4 columns" style="color: #44B6E8">
        {{currentTodo.type}}
      </div>
      <div class="small-12 medium-4 columns" style="margin-top: -9px;" *ngIf="!isCustomer">
        <input class="round-border" type="text" tpiq-custom-datepicker [format]="dateFormat" [mindate]="'past'" (valueChanged)="setDueDate($event)" [ngModel]="currentTodo.dueDate" placeholder="Due Date" style="border-radius: 10px;margin: 0px">
      </div>
      <div class="small-12 medium-4 columns text-right">
        <span class="stat-done" *ngIf="currentTodo.status == 'Done'">{{currentTodo.status}}</span>
        <span class="stat-assign" *ngIf="currentTodo.status == 'Assigned'">{{currentTodo.status}}</span>
      </div>
    </div>
    <div class="medium-9 columns todo-button float-left " *ngIf="!isStatusDone">
      <div class="todo-btn">
        <button class="button small btn-bg float-right stat-done" (click)="moveNextStatus('status')">MARK AS DONE</button>
      </div>
    </div>
    <div class="medium-9 columns todo-button float-left" *ngIf="isStatusDone">
      <div class="todo-btn">
        <button class="button small btn-bg float-right stat-assign" (click)="moveNextStatus('status')">MARK AS ASSIGNED</button>
      </div>
    </div>
  </div>
  <div class="collaboration medium-8" style="margin-bottom: 0px;margin-top: 6px" *ngIf="currentTodo && !currentTodo.postId">
    <app-new-post [companyId]="channelId" [channelType]="channelType" [org]="org" [pageType]="'company'" [labelTypes]="[]" [urgentLabelTypes]="[]"
                  [externalUsers]="[]" [posts]="[]" [entityType]="'todo'" [entityId]="currentTodo.id"
                  (onPostCreation)="createdPost($event)">
    </app-new-post>
    
  </div>
  <div class="collaboration medium-8" style="margin-bottom: 0px" *ngIf="currentTodo && currentTodo.postId">
    <app-post-wall [post]="currentPost" [companyId]="channelId" [channelType]="channelType" [org]="org" [pageType]="'company'" [labelTypes]="[]" [urgentlabelTypes]="[]" (onRemovePost)="deletePost($event)"></app-post-wall>
  </div>
</div>
<div class="callout text-center" *ngIf="noResultsFound">
No Results Found.
</div>
